function initTestimonialSlider(root) {
  const track = root.querySelector('.testimonial-slider__track');
  const slides = Array.from(root.querySelectorAll('.testimonial-slider__slide'));
  const prevBtn = root.querySelector('.testimonial-slider__arrow--prev');
  const nextBtn = root.querySelector('.testimonial-slider__arrow--next');
  const dotsWrap = root.querySelector('.testimonial-slider__dots');
  const counterCurrent = root.querySelector('.testimonial-slider__counter-current');
  const counterTotal = root.querySelector('.testimonial-slider__counter-total');

  if (!track || !slides.length) return;

  const autoscroll = root.dataset.autoscroll === 'true';
  const speed = parseInt(root.dataset.speed, 10) || 4000;

  let currentIndex = 0;
  let timer = null;

  function slidesVisible() {
    return window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
  }

  function maxIndex() {
    return Math.max(0, slides.length - slidesVisible());
  }

  function buildDots() {
    const count = maxIndex() + 1;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonial-slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          go(i);
        });
        dotsWrap.appendChild(dot);
      }
    }

    if (counterTotal) counterTotal.textContent = count;
  }

  function update() {
    const mi = maxIndex();
    if (currentIndex > mi) currentIndex = mi;
    if (currentIndex < 0) currentIndex = 0;

    const slideRect = slides[0].getBoundingClientRect();
    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.gap) || 0;
    const offset = currentIndex * (slideRect.width + gap);

    track.style.transform = 'translateX(-' + offset + 'px)';

    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= mi;

    if (dotsWrap) {
      Array.from(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    if (counterCurrent) counterCurrent.textContent = currentIndex + 1;
  }

  function go(index) {
    const mi = maxIndex();
    currentIndex = Math.max(0, Math.min(index, mi));
    update();
    if (autoscroll) {
      stopAuto();
      startAuto();
    }
  }

  function startAuto() {
    if (!autoscroll || maxIndex() === 0) return;
    stopAuto();
    timer = setInterval(function () {
      const mi = maxIndex();
      const next = currentIndex + 1 > mi ? 0 : currentIndex + 1;
      go(next);
    }, speed);
  }

  function stopAuto() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { go(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(currentIndex + 1); });

  root.addEventListener('mouseenter', stopAuto);
  root.addEventListener('mouseleave', startAuto);
  root.addEventListener('focusin', stopAuto);
  root.addEventListener('focusout', startAuto);

  window.addEventListener('resize', function () {
    buildDots();
    update();
  });

  buildDots();
  update();
  if (autoscroll) startAuto();
}

function initAllTestimonialSliders() {
  document
    .querySelectorAll('.testimonial-slider-section')
    .forEach(function (el) {
      if (el.dataset.tsInitialized) return;
      el.dataset.tsInitialized = 'true';
      initTestimonialSlider(el);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTestimonialSliders);
} else {
  initAllTestimonialSliders();
}

document.addEventListener('shopify:section:load', function (event) {
  const section = event.target.querySelector('.testimonial-slider-section');
  if (section && !section.dataset.tsInitialized) {
    section.dataset.tsInitialized = 'true';
    initTestimonialSlider(section);
  }
});